/**
 * Timezone-safe tarih formatlama.
 * "YYYY-MM-DD" → "DD.MM.YYYY" dönüşümünü Date nesnesi kullanmadan yapar.
 * Böylece tarayıcı timezone kayması (UTC vs local) riski ortadan kalkar.
 */
export function fmtDate(dateStr) {
  if (!dateStr) return '';
  const s = String(dateStr).trim();
  const validYear = (y) => y >= 1900 && y <= 2100;
  // YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss...
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const y = parseInt(m[1], 10);
    if (validYear(y)) return `${m[3]}.${m[2]}.${m[1]}`;
    return '—';
  }
  // DD.MM.YYYY already (yıl 4 hane ve geçerli aralıkta)
  const m2 = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (m2) {
    const y = parseInt(m2[3], 10);
    if (validYear(y)) return s;
    return '—';
  }
  // DD.MM.YY+ — yıl 4 haneden fazla → bozuk
  if (/^\d{1,2}\.\d{1,2}\.\d{5,}$/.test(s)) return '—';
  // Fallback: Date object (for non-standard formats)
  const d = new Date(s);
  if (!isNaN(d.getTime()) && validYear(d.getFullYear())) {
    return `${String(d.getDate()).padStart(2,'0')}.${String(d.getMonth()+1).padStart(2,'0')}.${d.getFullYear()}`;
  }
  return '—';
}
